import { Injectable } from '@angular/core';
import { Observable, interval, EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment-timezone';

@Injectable({
    providedIn: 'root',
})
export class WorkSessionService {
    public startWorkSessionTimer(startTime: string, useShortFormat: boolean = false): Observable<string> {
        if (!startTime) {
            return EMPTY;
        }

        return interval(1000).pipe(
            map(() => this.calculateTimeDifference(startTime, useShortFormat))
        );
    }

    private calculateTimeDifference(startTime: string, useShortFormat: boolean): string {
        const start = moment(startTime);
        const now = moment();
        const duration = moment.duration(now.diff(start));
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        if (useShortFormat) {
            return `${this.formatTwoDigits(hours)}:${this.formatTwoDigits(minutes)}:${this.formatTwoDigits(seconds)}`;
        }

        const hoursText = hours > 0 ? ` ${hours} hour${hours !== 1 ? 's' : ''}, ` : '';
        const minutesText = hours > 0 || minutes > 0 ? `${minutes} minute${minutes !== 1 ? 's' : ''}, and` : '';
        return `A work session started${hoursText}${minutesText} ${seconds} second${seconds !== 1 ? 's' : ''} ago.`;
    }

    private formatTwoDigits(num: number): string {
        return String(num).padStart(2, '0');
    }
}
